import { FleLayout } from "components/views/fle/FleLayout"
import { FlexRowCenter, Spacer } from "components/views/atoms/Atoms"
import { IlloExperts } from "components/views/atoms/Illustrations"
import { LeftArrowAndSpace, SpacerSwitcher, SwitchH1ToH2 } from "components/views/fle/Molecules"
import { Body } from "components/views/atoms/Bodies"
import { FleLinkWrapper } from "components/views/atoms/Links"
import { ArrowLink } from "components/views/atoms/links/ArrowLink"
import React from "react"

export const Answers = ({ onBack, onComplete, benefitConfiguration }) => (
  <FleLayout>
    <LeftArrowAndSpace onBack={onBack} />
    <div className="no-pointer-events">
      <FlexRowCenter>
        <IlloExperts />
      </FlexRowCenter>
    </div>
    <SpacerSwitcher />
    <SwitchH1ToH2>Expert answers are just a tap away.</SwitchH1ToH2>
    <Spacer height={0.5} />
    <Body color="black-80">Need help with your benefits? Have a medical question? Don’t know where to start?</Body>
    <Spacer height={0.5} />
    <Body color="black-80">
      Schedule a chat with a Carrot Care Team expert
      {benefitConfiguration.features.isLibraryEnabled && ", or browse a wealth of articles and videos"}.
    </Body>
    <FleLinkWrapper spacerHeight={1.5}>
      <ArrowLink onClick={onComplete}>Continue</ArrowLink>
    </FleLinkWrapper>
  </FleLayout>
)
